import axios from 'axios'
import { BASE_NEXT_API, getApiUrl } from '../../util/api/api'

import type { JobPostingProduct } from '../../../state/reducers/entitlement/entitlement'

const createDraft = (product: JobPostingProduct | null) =>
  axios.post(getApiUrl(`${BASE_NEXT_API}/job/create`), { product }, { withCredentials: true })

export default createDraft
